const IS_OPTIONS_REGEXP = /^options\.|^res\..*\.options\./;
const RESP_PART_REGEXP = /^(res\..*?\.)(.*)/;
const HTTP_REQ_REGEXP = /^http\.|^options\.http\./;
const WS_REQ_REGEXP = /^ws\.|^options\.ws\./;
const HTTP_RES_REGEXP = /^res\..*\.http\..*/;
const WS_RES_REGEXP = /^res\..*\.ws\..*/;
const RES_REGEXP = /^res\..*\./;

/**
 * Checks if subject is for an options request or response.
 * @param subject
 */
export const isOptionsMessage = (subject: string) => {
  return !!subject.match(IS_OPTIONS_REGEXP);
};

/**
 * Parses subject into response prefix (if any) and other request part.
 *
 * Example:
 *
 * `res.4b6ea636-bd61-4d1b-830f-cb25e59c6d55.http.get.foo`
 * Response part `res.4b6ea636-bd61-4d1b-830f-cb25e59c6d55`
 * Request part `http.get.foo`
 */
export const parseSubject = (subject: string) => {
  const subjectSplit = subject.match(RESP_PART_REGEXP);

  if (subjectSplit) {
    return {
      subjectResponsePart: subjectSplit[1],
      subjectRequestPart: subjectSplit[2]
    };
  }

  return {
    subjectResponsePart: "",
    subjectRequestPart: subject
  };
};

export const isHttpRequest = (subject: string) => {
  return subject.match(HTTP_REQ_REGEXP);
};

export const isHttpResponse = (subject: string) => {
  return subject.match(HTTP_RES_REGEXP);
};

export const isWebsocketRequest = (subject: string) => {
  return subject.match(WS_REQ_REGEXP);
};

export const isWebsocketResponse = (subject: string) => {
  return subject.match(WS_RES_REGEXP);
};

export const isResponseToRequest = (reqSubject: string, resSubject: string) => {
  return resSubject.match(new RegExp("res..*." + reqSubject.replace(".", ".")));
};

export const isResponse = (subject: string) => {
  return subject.match(RES_REGEXP);
};

export const shortenSubject = (subject: string) => {
  const { subjectResponsePart, subjectRequestPart } = parseSubject(subject);

  if (subjectResponsePart) {
    return "res.[...]." + subjectRequestPart;
  }
  return subject;
};
